// client/guest/components/BottomNav.tsx
import React from "react";

function onKeyActive(e: React.KeyboardEvent, cb: () => void) {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    cb();
  }
}

export default function BottomNav({
  onBack,
  onHome,
  hidden,
}: {
  onBack: () => void;
  onHome: () => void;
  hidden?: boolean;
}) {
  if (hidden) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-40">
      {/* лёгкое затемнение у нижнего края */}
      <div className="absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-black/45 via-black/20 to-transparent" />

      <div className="relative mx-auto max-w-xl px-4 pb-[calc(16px+env(safe-area-inset-bottom))]">
        <div className="pointer-events-auto mx-auto flex w-full max-w-[380px] items-end justify-center">
          {/* LEFT: Back */}
          <div className="flex flex-col items-center gap-1 mr-3">
            <div
              role="button"
              tabIndex={0}
              aria-label="Назад"
              onClick={onBack}
              onKeyDown={(e) => onKeyActive(e, onBack)}
              className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 hover:bg-white/16 active:bg-white/20 shadow-[0_2px_10px_rgba(0,0,0,.35)] ring-1 ring-white/10 transition select-none overflow-hidden outline-none focus:ring-2 focus:ring-white/20"
              style={{ WebkitTapHighlightColor: "transparent" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="block h-[18px] w-[18px] text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth={2.4}
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden
                focusable="false"
              >
                <path d="M15.75 19.5 8.25 12l7.5-7.5" />
              </svg>
            </div>
            <div className="text-[10px] leading-tight text-white/70">Назад</div>
          </div>

          {/* CENTER: Home (will stay perfectly centered) */}
          <div className="flex flex-col items-center gap-1">
            <div
              role="button"
              tabIndex={0}
              aria-label="Домой"
              onClick={onHome}
              onKeyDown={(e) => onKeyActive(e, onHome)}
              className="relative inline-flex h-9 min-w-[78px] items-center justify-center rounded-xl bg-white/10 hover:bg-white/16 active:bg-white/20 transition shadow-[0_2px_10px_rgba(0,0,0,.35)] ring-1 ring-white/10 select-none outline-none focus:ring-2 focus:ring-white/20"
              style={{ WebkitTapHighlightColor: "transparent" }}
            >
              <span aria-hidden className="block h-[5px] w-9 rounded-full bg-white/90 shadow-[0_0_10px_rgba(255,255,255,.55)]" />
            </div>
            <div className="text-[10px] leading-tight text-white/70">Домой</div>
          </div>

          {/* RIGHT: ghost spacer mirroring Back to keep Home centered */}
          <div className="flex flex-col items-center gap-1 ml-3 opacity-0 pointer-events-none select-none" aria-hidden>
            <div className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 ring-1 ring-white/10" />
            <div className="text-[10px] leading-tight">Назад</div>
          </div>
        </div>
      </div>
    </div>
  );
}